import {DeepLinkActionBase} from '../deep-link-action-base';
import {OpenCashierOptions} from "../../../../../common/interfaces/cashier.service.interface";
import {CHANNEL_ELEMENTS, CHANNEL_SOURCE} from "../../../../../common/const/casinofied-analytics-consts";
import {AreaType} from "@sparkware/uc-sdk-core";


export class CashierDeepLinkAction extends DeepLinkActionBase {

  async execute(): Promise<void> {

    await this._executeCurrentAction();

    if(!this.services.device.os.isMobileOS) {
      await this._executeNextAction();
    }
  }

  private _executeCurrentAction(): Promise<void> {
    return this.services.cashier.openCashier(
        this._buildCashierOptions(),
        this.descriptor.marketingParams,
        true);
  }


  private _buildCashierOptions(): OpenCashierOptions {
    let options: OpenCashierOptions = {
      urlParams: '',
      channel: {
        source: CHANNEL_SOURCE.casinoClient,
        area: AreaType.externalClick,
        element: CHANNEL_ELEMENTS.deepLink
      }
    };

    if(this.nextAction && this.services.device.os.isMobileOS) {
      options.urlParams = this.deepLinkBuilder.buildDeepLinkUrl(this.nextAction);
    }

    let params = this.descriptor.actionParams && this.descriptor.actionParams.id;
    if(params) {
      let cashierParams = params.split(',');
      if(cashierParams.length  > 0) {
        options.sessionType = cashierParams[0].trim();
        if(cashierParams.length > 1) {
          options.PromCode = cashierParams[1].trim();
        }
      }

    }

    return options;
  }
}
